import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { Link } from 'react-router-dom';
import { ListIcon } from 'assets/materialIcons/materialIcons';

const ListButton = (props) => {
    const {
        disabled,
        linkStyle,
        style,
        translate,
        url,
    } = props;

    const defaultLinkStyle = {
        textDecoration: 'none',
        display: 'inline-flex',
    };

    const elLinkStyle = Object.assign({}, defaultLinkStyle, linkStyle, style);

    return (
        <Link to={ url } style={ elLinkStyle }>
            <Button
                disabled={ disabled }
                icon={ <ListIcon color={ theme.palette.primary1Color } /> }
                title={ translate('actions.list') }
            />
        </Link>
    );
};

ListButton.defaultProps = {
    url: '',
};

ListButton.propTypes = {
    disabled: PropTypes.bool,
    linkStyle: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
    url: PropTypes.string,
};

export default translate(ListButton);



// WEBPACK FOOTER //
// ./src/components/button/ListButton.js